import { createUseStyles } from "react-jss";
import {
  BreakPointDesktop,
  BreakPointTablet,
  BreakPointMobile,
} from "../../../constants/dimension";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  mainLayout: {
    boxSizing: "border-box",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "&.hideFooter": {
      height: "100%",
    },
    "&.noHeader": {
      paddingTop: 0,
    },
    "&.fullHeight": {
      height: "100%",
      overflow: "auto",
      paddingBottom: 70,
      display: "grid",
      placeItems: "center",
      /**
       * webOS 22 only (`not (aspect-ratio)` = Chromium <=87; aspect-ratio shipped in 88):
       * its default `auto` grid row saturates, so pin the row to a definite 1fr track.
       */
      "@supports not (aspect-ratio: 1 / 1)": {
        placeItems: "stretch",
        gridTemplateRows: "minmax(0, 1fr)",
      },
    },
    paddingTop: 70,
    paddingBottom: 84,
    [BreakPointDesktop]: {
      paddingTop: 175,
      paddingBottom: 41,
    },
    "&.mobileShell": {
      // Fallback for browsers without dvh (e.g. webOS 22 / Chromium 87)
      fallbacks: { height: "100vh" },
      height: "100dvh",
      overflow: "hidden",
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  contentScroller: {
    boxSizing: "border-box",
    // Fallback for browsers without dvh (e.g. webOS 22 / Chromium 87)
    fallbacks: { height: "100vh" },
    height: "100dvh",
    paddingTop: 70,
    paddingBottom: 84,
    overflowY: "auto",
    overflowX: "hidden",
    WebkitOverflowScrolling: "touch",
    overscrollBehavior: "contain",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  icon: {
    width: 40,
    height: 40,
  },
  isAtTop: {
    background: `${theme.colors.TextSecondary} !important`,
  },
  hide: {
    display: "none !important",
  },
  bgImage: {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: -2,
    width: "100%",
    objectFit: "cover",
    "&.isConsole": {
      height: "100%",
    },
    [BreakPointDesktop]: {
      height: "100%",
    },
    [BreakPointTablet]: {
      height: 450,
    },
    [BreakPointMobile]: {
      height: 350,
    },
  },
  rightItem: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  userName: {
    display: "none",
    [BreakPointDesktop]: {
      display: "inherit",
    },
  },
}));
